import React, { useRef, useState } from 'react';
import {
  Typography,
  Paper,
  Box,
  MenuItem,
  InputLabel,
  Select,
  FormControl,
  TextField,
  Stack,
  Button,
  Divider,
  FormHelperText,
  Checkbox,
  Alert,
} from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Icon } from '@iconify/react';
import { Link, useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider, FieldArray, Formik } from 'formik';
import { useEffect } from 'react';
import { useSelector, useReducer, useDispatch } from 'react-redux';
import useResponsive from '../../../../Hooks/useResponsive';
import {
  applyLeave,
  getLeaveTypes,
  getAvailableCompLeave,
  getAvailableLeaveCredits,
} from '../../../../redux/features/leaveSlice';
import GlobalSelectField from '../../../../components/mui/GlobalSelectField';
import { useSnackbar } from 'notistack';
import * as yup from 'yup';
import GlobalWrapper from '../../../../components/Wrapper/GlobalWrapper';
import dayjs from 'dayjs';
// ---------------------------------------------------------
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

export default function LeaveApplication() {
  const smUp = useResponsive('up', 'sm');

  const mdUp = useResponsive('up', 'md');
  const leaveTypes = useSelector((state) => state.leave);
  const { availableCompData, loading, availableLeaveCredits } = useSelector((state) => state.leave);
  const dispatch = useDispatch();
  const [fromDate, setFrom] = useState(null);
  const [toDate, setToDate] = useState(null);
  // const [availableLeave, setAvailable] = useState("Not-Available");
  const [displayDuration, SetDisplayDuration] = useState(false);
  const [duration, setDuration] = useState('');
  const [numberOfDays, setNumberOfDays] = useState('');
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const [disableDates, setDisableDates] = useState(false);
  const [checkedItems, setCheckedItems] = React.useState([]);
  // ------------------available leave count----------------------------------------------------
  const [availableLeaveCount, setAvailableLeaveCount] = useState('Not-Available');

  useEffect(() => {
    dispatch(getLeaveTypes());
    dispatch(getAvailableCompLeave());
  }, []);

  const validationSchema = yup.object().shape({
    leaveTypeId: yup.number().required('please select leave type'),
    encashment: yup.boolean().when('leaveTypeId', {
      is: 14,
      then: yup.boolean().required('Please select encashment type'),
      otherwise: yup.boolean().notRequired(),
    }),
    fromDate: yup.string().when('encashment', {
      is: false,
      then: yup.string().required('please select From Date'),
      otherwise: yup.string().notRequired(),
    }),

    toDate: yup.string().when('encashment', {
      is: true,
      then: yup.string().notRequired(),
      otherwise: yup.string().required('please select to Date'),
    }),

    noOfDays: yup.string().when('encashment', {
      is: true,
      then: yup.string().required('no of days required'),
      otherwise: yup.string().notRequired(),
    }),
    halfday: yup.boolean().when({
      is: () => {
        return numberOfDays === 1 || numberOfDays === 0.5;
      },
      then: yup.boolean().required('this feild is required'),
    }),

    reason: yup.string().required('please Enter the reason for your leave'),
    wfh_tasks: yup.array().when('leaveTypeId', {
      is: 5, // Only validate if leaveTypeId === 5 (WFH)
      then: yup
        .array()
        .of(
          yup.object().shape({
            task_name: yup.string().required('Please add your task for WFH'),
          }),
        )
        .min(1, 'At least one task is required for WFH'),
      otherwise: yup.array().notRequired(),
    }),
  });

  const formik = useFormik({
    // enableReinitialize: true,
    initialValues: {
      compIds: checkedItems,
      leaveTypeId: '',
      fromDate: '',
      toDate: '',
      encashment: '',
      halfday: '',
      noOfDays: '',
      reason: '',
      wfh_tasks: [{ task_name: '' }],
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      if (values.halfday === '') {
        values.halfday = false;
      }
      if (values.leaveTypeId === 3 && checkedItems.length == 0) {
        enqueueSnackbar('Available leave not Selected..!', {
          variant: 'error',
        });
      } else {
        dispatch(applyLeave(values)).then((res) => {
          if (res.payload.status === 'error' || res.payload.status === 'failed') {
            enqueueSnackbar(res.payload.message, {
              variant: 'error',
            });
          } else if (res.payload.status === 'success') {
            enqueueSnackbar(res.payload.message, {
              variant: 'success',
            });
            navigate('/employeeservices/leave');
          }
        });
      }
    },
  });

  // -----------------------updated-available-leave-count-------------------------------

  useEffect(() => {
    if (formik.values.leaveTypeId != 3 && formik.values.fromDate && formik.values.toDate) {
      const data = {
        date: formik.values.fromDate,
        id: formik.values.leaveTypeId,
        toDate: formik.values.toDate,
      };
      dispatch(getAvailableLeaveCredits(data));
    }
  }, [formik.values.leaveTypeId, formik.values.fromDate, formik.values.toDate]);

  useEffect(() => {
    if (availableLeaveCredits) {
      setAvailableLeaveCount(availableLeaveCredits[0]?.leavesRemaining);
    }
  }, [availableLeaveCredits]);
  // ---------------------------------------------------------------------------------------

  useEffect(() => {
    formik.setFieldValue('compIds', checkedItems);
  }, [checkedItems]);

  const handleChangeFrom = (e) => {
    setFrom(e);
    formik.setFieldValue('fromDate', dayjs(e).format('YYYY-MM-DD'));
  };
  const handleChangeTo = (e) => {
    setToDate(e);
    formik.setFieldValue('toDate', dayjs(e).format('YYYY-MM-DD'));
  };

  const handleDuration = (e) => {
    if (e.target.value === 'Half-Day') {
      setDuration(e.target.value);
      formik.setFieldValue('halfday', true);
      setNumberOfDays(0.5);
    } else {
      setDuration(e.target.value);
      formik.setFieldValue('halfday', false);
      setNumberOfDays(1);
    }
  };

  useEffect(() => {
    setDuration('');
    if (fromDate && toDate) {
      const diff = new Date(fromDate).getTime() - new Date(toDate).getTime();
      const numOfDays = Math.floor(Math.abs(diff / (1000 * 60 * 60 * 24)));
      setNumberOfDays(numOfDays + 1);
      if (numOfDays <= 0) {
        SetDisplayDuration(true);
      } else {
        SetDisplayDuration(false);
      }
    }
  }, [fromDate, toDate]);
  // --------------------------------

  useEffect(() => {
    setAvailableLeaveCount('');
    const totalCreditBalance = availableCompData.reduce((sum, item) => sum + (item.credit_balance || 0), 0);

    if (formik.values.leaveTypeId == 3) {
      setAvailableLeaveCount(totalCreditBalance);
    }
    if (formik.values.leaveTypeId == 5) {
      formik.setFieldValue('halfday', false);
    }
    if (formik.values.leaveTypeId == 9) {
      setDisableDates('disablePastCurrentMonth');
    }
    if (formik.values.leaveTypeId == 8 || formik.values.leaveTypeId == 3) {
      setDisableDates('disableFutureAfter2Days');
    } else if (formik.values.leaveTypeId == 13) {
      setDisableDates('disablePastEnableTodayPlus1');
    } else {
      setDisableDates(null);
    }
  }, [formik.values.leaveTypeId]);
  const shouldDisableDate = (date) => {
    if (formik.values.leaveTypeId == 9) {
      const today = dayjs();
      const startOfMonth = today.startOf('month');
      const endOfMonth = today.endOf('month');

      // Disable dates before the current month and after the current month
      return date.isBefore(startOfMonth) || date.isAfter(endOfMonth);
    }
    const today = dayjs();

    if (disableDates === 'disableFutureAfter2Days') {
      const minDate = today.add(3, 'day');
      return date.isBefore(minDate, 'day'); // Disable past and up to today + 2
    }

    if (disableDates === 'disablePastEnableTodayPlus1') {
      const maxDate = today.add(1, 'day');
      return date.isBefore(today, 'day') || date.isAfter(maxDate, 'day'); // Disable past and dates beyond today + 1
    }

    return false; // No restriction
  };
  useEffect(() => {
    formik.setFieldValue('fromDate', '');
    formik.setFieldValue('toDate', '');
    formik.setFieldValue('encashment', '');
    formik.setFieldValue('encashment', false);
    setFrom(null);
    setToDate(null);
  }, [formik.values.leaveTypeId]);
  useEffect(() => {
    if (formik.values.leaveTypeId === 14) {
      formik.setFieldValue('fromDate', dayjs().format('YYYY-MM-DD'));
      formik.setFieldValue('encashment', false);
      setFrom(dayjs());
      setNumberOfDays('');

      // formik.setFieldValue("fromDate", dayjs().format("YYYY-MM-DD"));
    }
  }, [formik.values.leaveTypeId]);
  useEffect(() => {
    if (formik.values.encashment) {
      setNumberOfDays('');
      SetDisplayDuration(false);
    }
  }, [formik.values.encashment]);
  const AvailableCompLeaveList = () => {
    return (
      <>
        <TableContainer>
          <Table sx={{ maxWidth: 400 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>slNo</TableCell>
                <TableCell align="right">Credit</TableCell>
                <TableCell align="right">Date</TableCell>

                <TableCell align="right">Check</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {availableCompData.map((row) => (
                <TableRow key={row.serialNumber} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                  <TableCell component="th" scope="row">
                    {row.serialNumber}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {row.credit_balance}
                  </TableCell>
                  <TableCell align="right">{row.comp_work_date}</TableCell>
                  <TableCell align="right">
                    <Checkbox
                      checked={checkedItems.includes(row.emp_comp_work_id)}
                      onChange={(event) => {
                        if (event.target.checked) {
                          setCheckedItems((prev) => [...prev, row.emp_comp_work_id]);
                        } else {
                          setCheckedItems((prev) => prev.filter((id) => id !== row.emp_comp_work_id));
                        }
                      }}
                      inputProps={{ 'aria-label': 'controlled' }}
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </>
    );
  };

  return (
    <div>
      <GlobalWrapper title="Apply For Leave">
        {smUp && (
          <Paper elevation={3}>
            <Box
              sx={{
                height: 48,
                backgroundColor: 'grey.200',
                borderRadius: '8px 8px 0 0',
              }}
            ></Box>
            <FormikProvider value={formik}>
              <Form onSubmit={formik.handleSubmit}>
                <Box sx={{ padding: 6 }}>
                  <Box sx={{ minWidth: 120, margin: 2 }}>
                    <GlobalSelectField
                      options={{
                        name: 'leaveTypeId',
                        formik: formik,
                        data: leaveTypes.data,
                        label: 'Leave Type',
                        keys: {
                          id: 'leaveTypeId',
                          value: 'leaveNameFull',
                        },
                        sx: { width: '100%' },
                      }}
                    />
                  </Box>
                  {formik.values.leaveTypeId == 14 ? (
                    <Box sx={{ minWidth: 120, margin: 2 }}>
                      <GlobalSelectField
                        options={{
                          name: 'encashment',
                          formik: formik,
                          data: [
                            { id: true, name: 'Encashment' },
                            { id: false, name: 'Leave' },
                          ],
                          label: 'Earned Leave Type',
                          keys: {
                            id: 'id',
                            value: 'name',
                          },
                          sx: { width: '100%' },
                        }}
                      />
                    </Box>
                  ) : null}
                  {formik.values.encashment && formik.values.encashment == true ? (
                    <Box sx={{ margin: 2 }}>
                      <TextField
                        name="noOfDays"
                        label="No Of Days"
                        fullWidth
                        value={formik.values.noOfDays}
                        onChange={formik.handleChange}
                        variant="outlined"
                        error={formik.touched.noOfDays && Boolean(formik.errors.noOfDays)}
                        helperText={formik.errors.noOfDays}
                      />
                    </Box>
                  ) : null}

                  {/* <Box sx={{ margin: 2 }}>
                    <TextField
                      label="Available Leave"
                      fullWidth
                      value={availableLeave}
                      disabled
                      variant="filled"
                    />
                  </Box> */}
                  {formik.values.encashment == true ? null : (
                    <Box sx={{ margin: 2 }}>
                      {formik.values.leaveTypeId ? (
                        <Stack direction={'row'} spacing={2}>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              label="From Date"
                              value={dayjs(formik.values.fromDate)}
                              disablePast={
                                formik.values.leaveTypeId == 9 ||
                                formik.values.leaveTypeId == 10 ||
                                formik.values.leaveTypeId == 12
                                  ? false
                                  : true
                              }
                              inputFormat="DD/MM/YYYY"
                              onChange={handleChangeFrom}
                              shouldDisableDate={shouldDisableDate}
                              renderInput={(params) => (
                                <TextField
                                  fullWidth
                                  {...params}
                                  error={formik.touched.fromDate && Boolean(formik.errors.fromDate)}
                                  helperText={formik.errors.fromDate}
                                />
                              )}
                            />
                          </LocalizationProvider>

                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              label="To Date"
                              value={dayjs(formik.values.toDate)}
                              disablePast={
                                formik.values.leaveTypeId == 9 ||
                                formik.values.leaveTypeId == 10 ||
                                formik.values.leaveTypeId == 12
                                  ? false
                                  : true
                              }
                              inputFormat="DD/MM/YYYY"
                              name="date"
                              onChange={handleChangeTo}
                              // shouldDisableDate={
                              //   disableDates ? shouldDisableDate : undefined
                              // }
                              shouldDisableDate={shouldDisableDate}
                              renderInput={(params) => (
                                <TextField
                                  fullWidth
                                  {...params}
                                  error={formik.touched.fromDate && Boolean(formik.errors.fromDate)}
                                  helperText={formik.errors.fromDate}
                                />
                              )}
                            />
                          </LocalizationProvider>
                        </Stack>
                      ) : null}
                    </Box>
                  )}
                  <Box sx={{ margin: 2 }}>
                    <TextField
                      label="Available Leave"
                      fullWidth
                      disabled
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={availableLeaveCount}
                    />
                  </Box>

                  {displayDuration && (
                    <Box sx={{ margin: 2 }}>
                      <FormControl fullWidth error={Boolean(formik.errors.halfday)}>
                        <InputLabel id="Input-Label">Duration of Leave</InputLabel>
                        <Select
                          disabled={formik.values.leaveTypeId == 5 ? true : false}
                          labelId="Input-Label"
                          label="Duration of Leave"
                          onChange={handleDuration}
                          value={formik.values.leaveTypeId == 5 ? 'Full-Day' : duration}
                        >
                          <MenuItem value="Half-Day">Half-Day</MenuItem>
                          <MenuItem value="Full-Day">Full-Day</MenuItem>
                        </Select>
                        <FormHelperText>{formik.errors.halfday}</FormHelperText>
                      </FormControl>
                    </Box>
                  )}
                  {formik.values.encashment ? null : (
                    <Box sx={{ margin: 2 }}>
                      <TextField label="No.of Days" fullWidth disabled variant="filled" value={numberOfDays} />
                    </Box>
                  )}

                  <Box>
                    {formik.values.leaveTypeId === 3 ? (
                      <Box>
                        <Typography>Available Leave Credits</Typography>
                        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                          <AvailableCompLeaveList />
                        </Box>
                      </Box>
                    ) : null}
                  </Box>
                  <Box sx={{ margin: 2 }}>
                    <TextField
                      name="reason"
                      label="Reason"
                      placeholder="Enter the reason for leave"
                      fullWidth
                      variant="outlined"
                      multiline
                      minRows={4}
                      onChange={formik.handleChange}
                      error={formik.touched.reason && Boolean(formik.errors.reason)}
                      helperText={formik.errors.reason}
                    />
                  </Box>
                  {formik.values.leaveTypeId === 5 ? (
                    <Box sx={{ margin: 2 }}>
                      <Typography variant="h6" mb={1}>
                        Add Your Tasks
                      </Typography>
                      <FieldArray
                        name="wfh_tasks"
                        render={(arrayHelpers) => (
                          <Stack spacing={2}>
                            {formik.values.wfh_tasks.map((task, index) => (
                              <Stack direction="row" spacing={2} key={index} alignItems="center">
                                <TextField
                                  fullWidth
                                  name={`wfh_tasks[${index}].task_name`}
                                  label={`Task ${index + 1}`}
                                  placeholder="Enter the task to be completed"
                                  value={formik.values.wfh_tasks[index].task_name}
                                  onChange={formik.handleChange}
                                  error={
                                    formik.touched.wfh_tasks?.[index]?.task_name &&
                                    Boolean(formik.errors.wfh_tasks?.[index]?.task_name)
                                  }
                                  helperText={
                                    formik.touched.wfh_tasks?.[index]?.task_name &&
                                    formik.errors.wfh_tasks?.[index]?.task_name
                                  }
                                />
                                {formik.values.wfh_tasks.length > 1 && (
                                  <Button
                                    color="error"
                                    variant="outlined"
                                    size="small"
                                    startIcon={<Icon icon={'fluent:delete-20-regular'} />}
                                    onClick={() => arrayHelpers.remove(index)}
                                  >
                                    Delete
                                  </Button>
                                )}
                              </Stack>
                            ))}
                            <Button
                              size="small"
                              color="primary"
                              variant="contained"
                              startIcon={<Icon icon={'fluent:task-list-square-add-20-regular'} />}
                              sx={{ alignSelf: 'flex-start' }}
                              onClick={() => arrayHelpers.push({ task_name: '' })}
                            >
                              Add Task
                            </Button>
                          </Stack>
                        )}
                      />
                    </Box>
                  ) : null}

                  <Divider />
                  <Box
                    sx={{
                      paddingTop: 5,
                      display: 'flex',
                      justifyContent: 'flex-end',
                    }}
                  >
                    <Button variant="outlined">Reset</Button>

                    <Button
                      variant="contained"
                      type="submit"
                      disabled={formik.values.leaveTypeId === 5 && availableLeaveCount < 1}
                      value="Save"
                      sx={{ marginLeft: 2 }}
                    >
                      {loading ? 'Please wait...' : 'Save'}
                    </Button>
                  </Box>
                </Box>
              </Form>
            </FormikProvider>
          </Paper>
        )}
        {!smUp && (
          <Paper elevation={3} sx={{ width: '100%', marginTop: 3 }}>
            <Box
              sx={{
                height: 48,
                backgroundColor: 'grey.200',
                borderRadius: '8px 8px 0 0',
              }}
            ></Box>
            <FormikProvider value={formik}>
              <Form onSubmit={formik.handleSubmit}>
                <Box sx={{ padding: 2 }}>
                  <Box sx={{ minWidth: 120, margin: 2 }}>
                    <GlobalSelectField
                      options={{
                        name: 'leaveTypeId',
                        formik: formik,
                        data: leaveTypes.data,
                        label: 'Leave Type',
                        keys: {
                          id: 'leaveTypeId',
                          value: 'leaveNameFull',
                        },
                        sx: { width: '100%' },
                      }}
                    />
                  </Box>
                  {formik.values.leaveTypeId == 14 ? (
                    <Box sx={{ minWidth: 120, margin: 2 }}>
                      <GlobalSelectField
                        options={{
                          name: 'encashment',
                          formik: formik,
                          data: [
                            { id: true, name: 'Encashment' },
                            { id: false, name: 'Leave' },
                          ],
                          label: 'Earned Leave Type',
                          keys: {
                            id: 'id',
                            value: 'name',
                          },
                          sx: { width: '100%' },
                        }}
                      />
                    </Box>
                  ) : null}
                  {formik.values.encashment == true ? (
                    <Box sx={{ margin: 2 }}>
                      <TextField
                        name="noOfDays"
                        label="No Of Days"
                        fullWidth
                        value={formik.values.noOfDays}
                        onChange={formik.handleChange}
                        variant="outlined"
                        error={formik.touched.noOfDays && Boolean(formik.errors.noOfDays)}
                        helperText={formik.errors.noOfDays}
                      />
                    </Box>
                  ) : null}
                  {/* <Box sx={{ margin: 2 }}>
                    <TextField
                      label="Available Leave"
                      fullWidth
                      value={availableLeave}
                      disabled
                      variant="filled"
                    />
                  </Box> */}
                  {formik.values.encashment && formik.values.encashment == true ? null : (
                    <Box sx={{ margin: 2 }}>
                      {formik.values.leaveTypeId ? (
                        <Stack direction={'column'} spacing={2}>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              label="From Date"
                              value={dayjs(formik.values.fromDate)}
                              disablePast={
                                formik.values.leaveTypeId == 9 ||
                                formik.values.leaveTypeId == 10 ||
                                formik.values.leaveTypeId == 12
                                  ? false
                                  : true
                              }
                              inputFormat="DD/MM/YYYY"
                              onChange={handleChangeFrom}
                              shouldDisableDate={shouldDisableDate}
                              renderInput={(params) => (
                                <TextField
                                  fullWidth
                                  {...params}
                                  error={formik.touched.fromDate && Boolean(formik.errors.fromDate)}
                                  helperText={formik.errors.fromDate}
                                />
                              )}
                            />
                          </LocalizationProvider>

                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              label="To Date"
                              value={dayjs(formik.values.toDate)}
                              disablePast={
                                formik.values.leaveTypeId == 9 ||
                                formik.values.leaveTypeId == 10 ||
                                formik.values.leaveTypeId == 12
                                  ? false
                                  : true
                              }
                              inputFormat="DD/MM/YYYY"
                              name="date"
                              onChange={handleChangeTo}
                              shouldDisableDate={shouldDisableDate}
                              renderInput={(params) => (
                                <TextField
                                  fullWidth
                                  {...params}
                                  error={formik.touched.fromDate && Boolean(formik.errors.fromDate)}
                                  helperText={formik.errors.fromDate}
                                />
                              )}
                            />
                          </LocalizationProvider>
                        </Stack>
                      ) : null}
                    </Box>
                  )}
                  <Box sx={{ margin: 2 }}>
                    <TextField
                      label="Available Leave"
                      fullWidth
                      disabled
                      InputLabelProps={{ shrink: true }}
                      value={availableLeaveCount}
                    />
                  </Box>
                  {displayDuration && (
                    <Box sx={{ margin: 2 }}>
                      <FormControl fullWidth error={Boolean(formik.errors.halfday)}>
                        <InputLabel id="Input-Label">Duration of Leave</InputLabel>
                        <Select
                          labelId="Input-Label"
                          label="Duration of Leave"
                          onChange={handleDuration}
                          value={formik.values.leaveTypeId == 5 ? 'Full-Day' : duration}
                          disabled={formik.values.leaveTypeId == 5 ? true : false}
                        >
                          <MenuItem value="Half-Day">Half-Day</MenuItem>
                          <MenuItem value="Full-Day">Full-Day</MenuItem>
                        </Select>
                        <FormHelperText>{formik.errors.halfday}</FormHelperText>
                      </FormControl>
                    </Box>
                  )}
                  {formik.values.encashment ? null : (
                    <Box sx={{ margin: 2 }}>
                      <TextField label="No.of Days" fullWidth disabled variant="filled" value={numberOfDays} />
                    </Box>
                  )}
                  <Box>
                    {formik.values.leaveTypeId === 3 ? (
                      <Box>
                        <Typography>Available Leave Credits</Typography>
                        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                          <AvailableCompLeaveList />
                        </Box>
                      </Box>
                    ) : null}
                  </Box>
                  <Box sx={{ margin: 2 }}>
                    <TextField
                      name="reason"
                      label="Reason"
                      placeholder="Enter the reason for leave"
                      fullWidth
                      variant="outlined"
                      multiline
                      minRows={4}
                      onChange={formik.handleChange}
                      error={Boolean(formik.errors.reason)}
                      helperText={formik.errors.reason}
                    />
                  </Box>
                  {formik.values.leaveTypeId === 5 ? (
                    <Box sx={{ margin: 2 }}>
                      <Typography variant="h6" mb={1}>
                        Add Your Tasks
                      </Typography>
                      <FieldArray
                        name="wfh_tasks"
                        render={(arrayHelpers) => (
                          <Stack spacing={2}>
                            {formik.values.wfh_tasks.map((task, index) => (
                              <Stack direction="row" spacing={2} key={index} alignItems="center">
                                <TextField
                                  fullWidth
                                  name={`wfh_tasks[${index}].task_name`}
                                  label={`Task ${index + 1}`}
                                  placeholder="Enter the task to be completed"
                                  value={formik.values.wfh_tasks[index].task_name}
                                  onChange={formik.handleChange}
                                  error={
                                    formik.touched.wfh_tasks?.[index]?.task_name &&
                                    Boolean(formik.errors.wfh_tasks?.[index]?.task_name)
                                  }
                                  helperText={
                                    formik.touched.wfh_tasks?.[index]?.task_name &&
                                    formik.errors.wfh_tasks?.[index]?.task_name
                                  }
                                />
                                {formik.values.wfh_tasks.length > 1 && (
                                  <Button
                                    color="error"
                                    variant="outlined"
                                    size="small"
                                    onClick={() => arrayHelpers.remove(index)}
                                  >
                                    <Icon icon={'fluent:delete-20-regular'} />
                                  </Button>
                                )}
                              </Stack>
                            ))}
                            <Button
                              size="small"
                              color="primary"
                              variant="contained"
                              startIcon={<Icon icon={'fluent:task-list-square-add-20-regular'} />}
                              sx={{ alignSelf: 'flex-start' }}
                              onClick={() => arrayHelpers.push({ task_name: '' })}
                            >
                              Add Task
                            </Button>
                          </Stack>
                        )}
                      />
                    </Box>
                  ) : null}
                  <Divider />
                  <Box
                    sx={{
                      paddingTop: 5,
                      display: 'flex',
                      justifyContent: 'flex-end',
                    }}
                  >
                    <Button variant="outlined">Reset</Button>

                    <Button
                      variant="contained"
                      type="submit"
                      value="Save"
                      disabled={formik.values.leaveTypeId === 5 && availableLeaveCount < 1}
                      sx={{ marginLeft: 2 }}
                    >
                      {loading ? 'Please wait...' : 'Save'}
                    </Button>
                  </Box>
                </Box>
              </Form>
            </FormikProvider>
          </Paper>
        )}
      </GlobalWrapper>
    </div>
  );
}
